module.exports = __webpack_public_path__ + "img/hall3.455145f5.png";